import {IMessagesBag} from '../../@interfaces/services/Localisation/IMessagesBag';
import {
	LOCALE_CLEAR_LOCALISATIONS,
	LOCALE_FETCH_LOCALISATIONS,
	LOCALE_SET_FALLBACK_LOCALE,
	LOCALE_SET_LOCALE,
	LOCALE_SET_LOCALISATIONS
} from './constants';

export const fetchLocalisations = () => ({type: LOCALE_FETCH_LOCALISATIONS});
export const setLocalisations = (locales: IMessagesBag) => ({type: LOCALE_SET_LOCALISATIONS, payload: locales});
export const clearLocalisations = () => ({type: LOCALE_CLEAR_LOCALISATIONS});

export const setLocale = (locale: string) => ({type: LOCALE_SET_LOCALE, payload: locale});
export const setFallbackLocale = (locale: string) => ({type: LOCALE_SET_FALLBACK_LOCALE, payload: locale});
